import { getShortUrlParams } from '@op/components/FilterCommon/utils';
import { useHistory } from 'umi';
import { useEffect, useState } from 'react';

interface IUseGetShortId {
  shortid?: string;
  defaultValue?: any;
  useDefaultTime?: boolean;
  needRequest?: boolean;
  defaultLoading?: boolean;
}

/**
 * 获取shortid的过滤器信息
 * @param shortid 获取过滤器的id
 * @param useDefaultTime 是否使用默认值的时间，而放弃shortid的时间
 * @param defaultValue 默认值
 * @returns
 */
export function useGetShortId({
  shortid,
  defaultValue,
  useDefaultTime = false,
  needRequest = true,
  defaultLoading = true,
}: IUseGetShortId) {
  const history = useHistory();
  const [loading, setLoading] = useState(defaultLoading);
  const [filter, setFilter] = useState<any>(null);

  async function requestShrotId() {
    setLoading(true);
    let id = shortid;
    if (useDefaultTime && !id?.includes('-')) {
      id = `${id}-1`;
    }
    const params = await getShortUrlParams(
      history,
      shortid,
      defaultValue,
      false,
    );
    setFilter(params);
    setLoading(false);
  }

  useEffect(() => {
    if (shortid && needRequest) {
      requestShrotId();
    }
  }, [shortid]);

  return { loading, filter };
}
